import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Survey } from 'survey-react-ui';
import { Model } from 'survey-core';
import { SharpLight } from "survey-core/themes/sharp-light";
import "survey-core/defaultV2.min.css";

import axios from 'axios';
import { storageKeys } from '../../constants/storageKeys';
import Cookies from 'js-cookie';

// Async function to save survey answers
const saveSurvey = async (answers, surveyName) => {
  const sessionID = localStorage.getItem(storageKeys.SESSION_ID);
  if (sessionID) {
    try {
      await axios.post(`${process.env.REACT_APP_PROXY}/upload/survey`, {
        sessionID,
        surveyName,
        answers
      });
      console.log('Survey saved successfully.');
    } catch (error) {
      console.error('Error saving survey:', error);
    }
  } else {
    console.error('Session ID does not exist.');
  }
};

const SurveyPage = ({ surveyJson, onSurveyComplete = null }) => {
  const navigate = useNavigate();
  const sessionKey = Cookies.get('sessionKey');

  useEffect(() => {
    // Redirect to home page if sessionID does not exist
    const sessionID = localStorage.getItem(storageKeys.SESSION_ID);
    if (!sessionID) {
      navigate('/home');
      return;
    }
  }, [navigate]);

  // Initialize survey model and apply theme
  const surveyModel = new Model(surveyJson);
  surveyModel.applyTheme(SharpLight);

  // Handle survey completion
  surveyModel.onComplete.add(async (sender, options) => {
    const answers = sender.data;

    // Only save if there are answers
    if (Object.keys(answers).length > 0) {
      const surveyName = surveyJson.name;
      await saveSurvey(answers, surveyName);
    }
    if (sessionKey) {
      try {
        await axios.post(`${process.env.REACT_APP_PROXY}/session/${sessionKey}/complete-step`, {
          stepIndex: sessionStorage.getItem('stepIndex')
        });

        if (onSurveyComplete) {
          onSurveyComplete(); // ✅ Trigger re-fetch from parent
        }

      } catch (error) {
        console.error('Error updating session:', error);
      }
    } else {
      alert('Survey completed successfully! Thank You!');
      navigate('/home');
    }
  });

  if (!surveyJson) return <div>Error loading survey.</div>;

  return <Survey model={surveyModel} />;
};

export default SurveyPage;
